import {IOrderModel} from '../../../../src/@interfaces/models/Order/IOrderModel';
import {Props} from '../../../../src/components/Form/FormField';
import React from 'react';
import OrderReactionTimeExpired from './OrderReactionTimeExpired';
import {OrderStatusWithCommentField} from './OrderStatusWithCommentField';

export default function OrderStatusIdField<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    const orderId = props.model?.id;
    if (!orderId || !props.formName) {
        return <OrderStatusWithCommentField {...props}/>;
    }

    return <OrderReactionTimeExpired
            orderId={orderId}
            controllerName={props.formName}
            shouldDisplay={props.model?.status_requires_reason_of_expiration === true}
            message="OrderStatusIdField.reaction-time-is-expired-message"
    >
        <OrderStatusWithCommentField {...props}/>
    </OrderReactionTimeExpired>;
}
